const Award = () => import(/* webpackChunkName: "manager" */ './Index');
const Personal = () => import(/* webpackChunkName: "personal" */ './Personal');

export default {
  routes: [
    {
      path: '/awar/index',
      name: 'awar_index',
      component: Award
    },
    {
      path: '/awar/personal',
      name: 'awar_personal',
      component: Personal
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/awar/router.js